module.exports = __webpack_public_path__ + "fonts/Barlow-Italic.3214ae8c.ttf";